"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var GroupSeparator =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(GroupSeparator, _PureComponent);

  function GroupSeparator() {
    (0, _classCallCheck2.default)(this, GroupSeparator);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(GroupSeparator).apply(this, arguments));
  }

  (0, _createClass2.default)(GroupSeparator, [{
    key: "langKey",
    value: function langKey(suffix) {
      return "AudienceTargeting." + suffix;
    }
  }, {
    key: "getClassName",
    value: function getClassName(name, suffix) {
      return "" + name + (suffix ? "-" + suffix : '');
    }
  }, {
    key: "render",
    value: function render() {
      var value = this.props.value;
      return _react.default.createElement("div", {
        className: this.getClassName("group-separator-line " + this.props.className, value)
      }, _react.default.createElement("span", {
        className: this.getClassName('group-separator-text', value)
      }, value && _I18n.default.text(this.langKey(value))));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        className: _react.PropTypes.string,
        value: _react.PropTypes.string
      };
    }
  }]);
  return GroupSeparator;
}(_react.PureComponent);

exports.default = GroupSeparator;
module.exports = exports.default;